import data from "../../.sourceflow/specialisms.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const specialisms_helper = new CollectionHelper(data);
